import licenseModule from '../license.module';
import angular from 'angular';

export default licenseModule.factory('LicenseOverviewService', [
    '$q',
    '$timeout',
    '__env',
    'accountService',
    'alertLevelConstants',
    LicenseOverviewService
]);

function LicenseOverviewService(
    $q,
    $timeout,
    __env,
    accountService,
    alertLevelConstants
) {
    var purchasesHistory = require('./licenseOverviewService.purchasesHistory.mock');

    function getBillingContactInformation() {
        var defer = $q.defer();
        var promises = [];

        promises.push(accountService.getBillingInformation());

        $q.all(promises).then(function(results) {
            var billingInformationResponse = results[0];

            var billingView = {
                name: billingInformationResponse.name,
                aan: billingInformationResponse.aan,
                address: billingInformationResponse.address,
                phone: billingInformationResponse.contactNo,
                email: billingInformationResponse.email
            };

            var billingContactInformation = require('./licenseOverviewService.billingContactInformation.mock');
            billingView = angular.merge(
                {},
                billingContactInformation,
                billingView
            );

            defer.resolve(billingView);
        }, defer.reject);

        return defer.promise;
    }

    function getCloudSubscriptionSummary() {
        var defer = $q.defer();
        var promises = [];

        promises.push(accountService.getTotalUsage());
        promises.push(accountService.getSubscriptionEntitlement());
        promises.push(accountService.getPlanInformation());

        $q.all(promises).then(function(results) {
            var usageResponse = results[0];
            var entitlementResponse = results[1];
            var planInformationResponse = results[2];

            var subscriptionView = {
                plan: planInformationResponse.name,
                startDate: new Date(planInformationResponse.startDate),
                endDate: new Date(planInformationResponse.endDate),
                cloudBandwidthUsed:
                    usageResponse.totalIds.usage &&
                    usageResponse.totalIds.usage.bandwidth
                        ? usageResponse.totalIds.usage.bandwidth
                        : 0,
                cloudStorageTotal: entitlementResponse.cloudStorage,
                cloudBandwidthTotal: entitlementResponse.cloudBandwidth,
                storage: {
                    alertLevel:
                        usageResponse.storage &&
                        usageResponse.storage.alertLevel
                            ? usageResponse.storage.alertLevel
                            : alertLevelConstants.none,
                    usage: usageResponse.storage
                        ? usageResponse.storage.usage
                        : 0
                },
                bandwidthDetail: {
                    alertLevel:
                        usageResponse.bandwidthDetail &&
                        usageResponse.bandwidthDetail.alertLevel
                            ? usageResponse.bandwidthDetail.alertLevel
                            : alertLevelConstants.none,
                    usage: usageResponse.bandwidthDetail
                        ? usageResponse.bandwidthDetail.usage
                        : null
                }
            };

            var cloudSubscriptionSummary = require('./licenseOverviewService.cloudSubscriptionSummary.mock');
            subscriptionView = angular.merge(
                {},
                cloudSubscriptionSummary,
                subscriptionView
            );

            defer.resolve(subscriptionView);
        }, defer.reject);

        return defer.promise;
    }

    function getPlanInfoSummary() {
        var defer = $q.defer();
        var promises = [];

        promises.push(accountService.getSubscriptionEntitlement());
        promises.push(accountService.getPlanInformation());

        $q.all(promises).then(function(results) {
            var entitlementResponse = results[0];
            var planInformationResponse = results[1];

            var planView = {
                plan: planInformationResponse.name,
                startDate: new Date(planInformationResponse.startDate),
                endDate:
                    planInformationResponse.endDate == '0001-01-01T00:00:00'
                        ? null
                        : new Date(planInformationResponse.endDate),
                planStatus: planInformationResponse.status.toLowerCase(),
                planDescription: planInformationResponse.description,
                cloudStorageTotal: entitlementResponse.cloudStorage,
                cloudBandwidthTotal: entitlementResponse.cloudBandwidth,
                totalDeviceId: entitlementResponse.ids.subscription.deviceIds,
                totalPremiumUserId:
                    entitlementResponse.ids.subscription.premiumIds,
                hasOnPrem: planInformationResponse.createInstance,
                hasPerpetual: true,
                planType: planInformationResponse.type.toLowerCase()
            };

            if (
                entitlementResponse.ids.perpetual.deviceIds > 0 ||
                entitlementResponse.ids.perpetual.premiumIds > 0
            ) {
                planView.hasPerpetual = true;
            } else {
                planView.hasPerpetual = false;
            }

            var planInfoSummary = require('./licenseOverviewService.planInfoSummary.mock');
            planView = angular.merge({}, planInfoSummary, planView);
            defer.resolve(planView);
        });
        return defer.promise;
    }

    function getPurchasesHistory() {
        var defer = $q.defer();
        $timeout(function() {}, 1000).then(function() {
            defer.resolve(purchasesHistory);
        });
        return defer.promise;
    }

    return {
        getBillingContactInformation: getBillingContactInformation,
        getCloudSubscriptionSummary: getCloudSubscriptionSummary,
        getPlanInfoSummary: getPlanInfoSummary,
        getPurchasesHistory: getPurchasesHistory
    };
}



// WEBPACK FOOTER //
// ./modules/license/services/licenseOverviewService.service.js